module.exports = __webpack_public_path__ + "static/media/bin.7c6464f4.png";